import Hero from './components/Hero';
import Stats from './components/Stats';
import Services from './components/Services';
import Features from './components/Features';
import Cases from './components/Cases';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import CTA from './components/CTA';
import { heroData, serviceData, featureData, caseData, testimonialData, faqData } from '@/mocks/homeData';

export default function Home() {
  const jsonLdWebPage = JSON.stringify({
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "17.c 起草官网首页",
    "description": "专业文件起草与官网建设一站式服务平台",
    "url": "https://17.c",
    "isPartOf": { "@type": "WebSite", "name": "17.c 起草官网", "url": "https://17.c" }
  });

  const jsonLdFAQ = JSON.stringify({
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqData.map(faq => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": { "@type": "Answer", "text": faq.answer }
    }))
  });

  return (
    <>
      <title>17.c 起草官网 - 专业文件起草与官网建设一站式服务</title>
      <meta name="description" content="17.c 起草官网是您专业文件起草与官方网站建设的首选平台。提供高效、规范的文件起草服务，助力企业快速搭建权威官网，提升品牌公信力与线上影响力。" />
      <link rel="canonical" href="https://17.c" />
      <script type="application/ld+json">{jsonLdWebPage}</script>
      <script type="application/ld+json">{jsonLdFAQ}</script>

      <Hero
        title={heroData.title}
        subtitle={heroData.subtitle}
        ctaText={heroData.ctaText}
        ctaLink={heroData.ctaLink}
        secondaryText={heroData.secondaryText}
        secondaryLink={heroData.secondaryLink}
      />
      <Stats />
      <Services services={serviceData} />
      <Features features={featureData} />
      <Cases cases={caseData} />
      <Testimonials testimonials={testimonialData} />
      <FAQ faqs={faqData} />
      <CTA />
    </>
  );
}